import React from "react";

const ViewRole = ({role}) => {
  return (
    <div className="grid grid-cols-3 gap-5 p-5 mb-20">
      <div>
        <span className="text-gray-400 text-sm">Module Name</span>
        <p>{role?.moduleName || ""}</p>
      </div>

      <div>
        <span className="text-gray-400 text-sm">Role Name</span>
        <p>{role?.roleName || ""}</p>
      </div>

      <div>
        <span className="text-gray-400 text-sm">Role Type</span>
        <p>{role?.roleType || ""}</p>
      </div>
    </div>
  );
};

export default ViewRole;
